import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get, create, remove, update } from '~/actions/customersNew';
import Spinner from '~/components/Spinner';
import Input from 'react-toolbox/lib/input';
import Checkbox from 'react-toolbox/lib/checkbox';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      changes: {},
      customer: {},
    };
  }

  componentDidMount() {
    if (this.props.data.id) {
      this.read();
    }
  }

  create() {
    return create(this.props.dispatch, this.context.apiClient, this.state.changes)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  read() {
    this.setState({ loading: true });
    return get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then((r) => this.setState({ loading: false, customer: r.data }));
  }

  update() {
    return update(
      this.props.dispatch,
      this.context.apiClient,
      this.state.customer.id,
      this.state.changes,
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    return remove(this.props.dispatch, this.context.apiClient, this.state.customer.id)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onRemove && this.props.data.onRemove());
  }

  renderInput(key, label) {
    return (<Input
      type="text"
      disabled={!this.props.data.editMode}
      label={label}
      value={this.state.changes[key] !== undefined
        ? this.state.changes[key] : this.state.customer[key]}
      onChange={v => this.setState({ changes: { ...this.state.changes, [key]: v } })}
    />);
  }

  renderCheckbox(key, label) {
    return (
      <Checkbox
        checked={this.state.changes[key] !== undefined
          ? this.state.changes[key] : this.state.customer[key]}
        label={label}
        onChange={v => this.setState({ changes: { ...this.state.changes, [key]: !!v } })}
      />
    );
  }

  renderContent() {
    return (
      <div>
        <div style={{ overflow: 'auto', maxHeight: '80vh' }}>
          {this.renderInput('firstName', 'First Name')}
          {this.renderInput('lastName', 'Last Name')}
          {this.renderCheckbox('distributor', 'Distributor')}
          {this.renderInput('level', 'Level')}
          {this.renderInput('company', 'Company')}
          {this.renderInput('email', 'Email')}
          {this.renderInput('phone', 'Phone')}
          {this.renderInput('lot', 'Lot')}
          {this.renderInput('country', 'Country')}
          {this.renderInput('state', 'State')}
          {this.renderInput('city', 'City')}
          {this.renderInput('zip', 'Zip')}
          {this.renderInput('address1', 'Address1')}
          {this.renderInput('address2', 'Address2')}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
          {this.state.loading && <Spinner />}
          {!this.state.loading && !this.props.data.id && this.props.data.editMode && <Button label="Create" style={{ margin: '0px 5px 0px 0px' }} primary raised onClick={() => this.create()} />}
          {!this.state.loading && this.props.data.id && this.props.data.editMode && <Button label="Update" style={{ margin: '0px 5px 0px 0px' }} primary raised onClick={() => this.update()} />}
          {!this.state.loading && this.props.data.id && this.props.data.editMode && <Button label="Remove" style={{ margin: '0px 5px 0px 0px' }} primary raised onClick={() => this.remove()} />}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/CustomersNew/index.js